<template>
  <div v-show="show">
    <v-dialog v-model="show" width="800px" >
      <v-container class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title
                primary-title
                class="px-2 py-1 white--text secondary"
              >
                <h3 class="mx-2">{{ title }}</h3>
                <v-spacer></v-spacer>
                <v-btn class="ma-0" icon @click="close">
                  <v-icon color="white">close</v-icon>
                </v-btn>
              </v-card-title>
              <v-layout row wrap justify-center class="px-3">
                <p class="mt-3  flex xs12 subheading" style="direction:ltr">
                  {{ message }}
                </p>
              </v-layout>

              <v-card-actions class="di-flex justify-end px-3 pb-3">
                <div class="text-xs-right mt-2">
                  <v-btn flat @click="close">Cancel</v-btn>
                  <v-btn color="primary" @click="confirm">Confirm</v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    show: false,
    title: "Low Credit Alert",
    message: "Account balance is negative, Are you sure you want to continue?",
  }),
  computed: {
    model: {
      get() {
        return this.show;
      },
      set() {
        this.close();
      },
    },
  },
  methods: {
    confirm() {
      this.$emit("confirmed");
      this.show = false;
      // this.close();
    },

    close() {
      this.loading = false;
      this.show = false;
      this.$emit("closed");
    },
  },
};
</script>
